import request from '@/utils/request'

let BasisApi = {

  /*医生/患者列表*/
  list(data) {
    return request._post('/shop/plus.basis.Index/index', data);
},
/*添加医生/患者*/
add(data) {
    return request._post('/shop/plus.basis.Index/add', data);
},
/*修改医生/患者*/
edit(data) {
    return request._post('/shop/plus.basis.Index/edit', data);
},
/*删除医生/患者*/
del(data) {
    return request._post('/shop/plus.basis.Index/del', data);
},
/*医生/患者详情*/
detail(data) {
  return request._post('/shop/plus.basis.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.basis.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.basis.Setting/getSetting', data, errorback);
    },
}
export default BasisApi;



// WEBPACK FOOTER //
// ./src/api/basis.js